module.exports = __webpack_public_path__ + "media/img/pages/profile/lidl ger 5-ca3ced48bc0a3212c680f5a8807c00b0.jpg";